import Vue       from 'vue'
import DOMPurify from 'dompurify'

/**
 * Global default configuration for DOMPurify.
 * - USE_PROFILES: { html: true } restricts parsing to standard HTML
 *   (disabling riskier vectors like SVG/MathML by default).
 */
const GLOBAL_DEFAULT_CONFIG = {
  USE_PROFILES: { html: true }
  // Uncomment and customize these if you want strict global constraints:
  // ALLOWED_TAGS: ['p', 'b', 'i', 'strong', 'em', 'a', 'ul', 'ol', 'li', 'br', 'h1', 'h2', 'h3'],
  // ALLOWED_ATTR: ['href', 'title', 'target'],
  // ALLOWED_URI_REGEXP: /^(?:https?|mailto|tel):/i
}

/**
 * Helper function to parse input and inject sanitized HTML safely.
 */
function renderSafeHtml (el, binding) {
  const value = binding.value
  let html = ''
  let customConfig = GLOBAL_DEFAULT_CONFIG

  // Check if an object was passed: { html: '...', config: { ... } }
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    html = value.html || ''
    customConfig = { ...GLOBAL_DEFAULT_CONFIG, ...(value.config || {}) }
  } else {
    // Otherwise, treat it as a raw string
    html = typeof value === 'string' ? value : String(value || '')
  }

  // Sanitize using DOMPurify and update the element's innerHTML
  el.innerHTML = DOMPurify.sanitize(html, customConfig)
}

/**
 * Register the custom directive globally in Vue 2
 */
Vue.directive('safe-html', {
  bind (el, binding) {
    renderSafeHtml(el, binding)
  },
  update (el, binding) {
    // Only re-sanitize and update if the binding value has actually changed
    if (binding.value !== binding.oldValue) {
      renderSafeHtml(el, binding)
    }
  }
})
